module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kenneth C. Davis\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Kenneth C. Davis")]), _vm._v(" is the "), _c('I', [_vm._v("New York Times")]), _vm._v(" bestselling author of "), _c('I', [_vm._v("America’s Hidden History")]), _vm._v(" and "), _c('I', [_vm._v("Don’t Know Much About")]), _vm._v("® "), _c('I', [_vm._v("History")]), _vm._v(", which gave rise to the Don’t Know Much About® series of books for adults and children. A frequent guest on national television and radio and a Ted-Ed Educator, Davis enjoys Skype visits with middle- and high-school classrooms to discuss history. He lives in New York City and can be found at dontknowmuch.com.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/pDTMOl/images/9781627793124.jpg?1717845127865",
      "alt": "This image is the cover for the book In the Shadow of Liberty"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("In the Shadow of Liberty\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Did you know that many of America’s Founding Fathers—who fought for liberty and justice for all—were slave owners? "), _c('br'), _c('br'), _vm._v("Through the powerful stories of five enslaved people who were “owned” by four of our greatest presidents, this book helps set the record straight about the role slavery played in the founding of America. From Billy Lee, valet to George Washington, to Alfred Jackson, faithful servant of Andrew Jackson, these dramatic narratives explore our country’s great tragedy—that a nation “conceived in liberty” was also born in shackles."), _c('br'), _c('br'), _vm._v("These stories help us know the real people who were essential to the birth of this nation but traditionally have been left out of the history books.  Their stories are true—and they should be heard."), _c('br'), _c('br'), _vm._v("This thoroughly-researched and documented book can be worked into multiple aspects of the common core curriculum.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Henry Holt and Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0